<div class="header">
  <div>
    <h2>{{ "learningBlockCases.title" | translate }}</h2>
  </div>
  <app-page-help>{{ "learningBlockCases.help" | translate }}</app-page-help>
</div>

@if (loading) {
  <app-page-loader></app-page-loader>
} @else if (loadFailed) {
  <nb-card>
    <nb-card-body class="load-failed">
      <p>{{ "learningBlockCases.loadError" | translate }}</p>
      <button nbButton status="primary" size="small" type="button" (click)="load(true)">
        <nb-icon icon="refresh-outline"></nb-icon>{{ "learningBlockCases.retry" | translate }}
      </button>
    </nb-card-body>
  </nb-card>
} @else {
  <nb-card>
    <nb-card-header>
      <h6>{{ "learningBlockCases.cases.title" | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <div class="filters">
        <nb-select
          size="small"
          [selected]="statusFilter"
          (selectedChange)="onStatusFilterChange($event)"
          [attr.aria-label]="'learningBlockCases.cases.filterLabel' | translate"
        >
          @for (f of statusFilters; track f) {
            <nb-option [value]="f">{{ "learningBlockCases.cases.filter." + f | translate }}</nb-option>
          }
        </nb-select>
      </div>

      <!-- A condensation run can take a while. The table is hidden, not
           removed (#casesTable stays alive), so nothing can be triggered
           twice. CLAUDE.md rule 19, stage C. -->
      @if (distilling) {
        <app-orbi-loader
          class="distilling-loader"
          [label]="
            (distilling === 'force' ? 'learningBlockCases.cases.distillingForce' : 'learningBlockCases.cases.distilling')
              | translate
          "
        ></app-orbi-loader>
      }
      <app-table
        #casesTable
        [hidden]="!!distilling"
        rowIdKey="id"
        [title]="''"
        [columns]="caseColumns"
        [data]="filteredCases"
        [rowActions]="caseRowActions"
        [globalActions]="caseGlobalActions"
        [selectable]="false"
        [maxVisibleItems]="25"
        (event)="onCaseEvent($event)"
      ></app-table>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-header>
      <h6>{{ "learningBlockCases.usage.title" | translate: { days: thresholds.days } }}</h6>
    </nb-card-header>
    <nb-card-body>
      <app-table
        rowIdKey="component"
        [title]="''"
        [columns]="usageColumns"
        [data]="usage"
        [selectable]="false"
      ></app-table>
      <!-- One line, no whitespace around the text: `.page-hint` is pre-line. -->
      <p class="page-hint">{{ thresholdsText }} {{ lastRunText }}@if (lastRunError) {<span class="run-error"> · {{ lastRunError }}</span>}</p>
    </nb-card-body>
  </nb-card>
}
